import { render } from "./Onboardv3.vue?vue&type=template&id=de9310f6&scoped=true"
import script from "./Onboardv3.vue?vue&type=script&lang=js"
export * from "./Onboardv3.vue?vue&type=script&lang=js"

import "./Onboardv3.vue?vue&type=style&index=0&id=de9310f6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\utente\\Documents\\GitHub\\SCIENZE_NATURALI_app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de9310f6"]])

export default __exports__